<template>
  <div>
    <el-row class="title-bar" type="flex" justify="space-between">
      <div class="vertical-center-box">
        <div class="title-h4 mr-r15">E2E 에이전트 연결</div>
        <span>다수의 에이전트를 E2E 서비스에 연결할 수 있습니다.</span>
      </div>
      <div class="vertical-center-box">
        <el-button class="mr-r4" size="small" @click="onBackLayerButton">전단계</el-button>
        <el-button size="small" type="primary" @click="onE2eRegistButton" :disabled="selectedRowArray.length === 0">저장</el-button>
      </div>
    </el-row>
    <el-table-wrapper ref="e2eAgentTable" @selection-change="changeHandleSelection"
      border :data="tableData" :columns="tableColumn" :column-default="columnDefault" :pagination="true" :show-search-tool="showSearchTool"
      style="width:100%;" header-align="center" :show-custom-header="true">
    </el-table-wrapper>
  </div>
</template>

<script>
import { forEach, isNil } from 'lodash';
import { columnDefault } from '@/constants/table';
import { EMPTY_TEXT } from '@/utils/string';
import DeviceRegistrationE2eApi from '@/api/settings/common/device-registration-e2e';

export default {
  name: 'WE2eRegistWizardForAgent',
  props: {
    wizardMode: {
      type: String,
    },
    targetTransactionId: {
      type: Number,
    },
    agentData: Array,
  },
  data() {
    return {
      tableData: [],
      selectedRowArray: [],
      showSearchTool: false,
      columnDefault,
      tableColumn: [
        {
          align: 'center',
          type: 'selection',
        },
        {
          prop: 'objName',
          label: '에이전트명',
        },
        {
          prop: 'ipaddress',
          label: '에이전트 IP',
        },
        {
          prop: 'orderbyIndex',
          label: '정렬순서',
          formatter: this.getEmptyText,
        },
      ],
    };
  },
  watch: {
    agentData(data) {
      this.tableData = data;
    },
  },
  // mounted() {
  //   // agentList api
  //   const params = {
  //     searchParamList: {
  //       field: '',
  //       value: '',
  //     },
  //   };
  //   DeviceRegistrationE2eApi.getAgentList(params).then((response) => {
  //     this.tableData = response.data.data;
  //   });
  // },
  methods: {
    onBackLayerButton() {
      this.$emit('on-back-layer-button');
      this.$refs.e2eAgentTable.$children[0].clearSelection();
    },
    // 최종 저장 함수 호출
    onE2eRegistButton() {
      this.$emit('on-e2e-regist-button', this.selectedRowArray);
    },
    changeHandleSelection(selectVal) {
      this.selectedRowArray = selectVal;
    },
    // 에이전트 리스트 호출전 값 세팅 함수
    onSettingAgentList() {
      this.$refs.e2eAgentTable.$children[0].clearSelection();
      if (this.wizardMode === 'update') {
        DeviceRegistrationE2eApi.getAgentSelectList({ transactionId: this.targetTransactionId }).then((response) => {
          const targetArr = [];
          forEach(response.data.data, (item) => {
            targetArr.push(this.tableData.find((targetItem) => targetItem.agentId === item.agentId));
          });
          forEach(targetArr, (item) => {
            this.$refs.e2eAgentTable.$children[0].toggleRowSelection(item);
          });
        });
      }
    },
    getEmptyText(row, column, value) {
      if (!isNil(value)) {
        return value;
      }
      return EMPTY_TEXT;
    },
  },
};
</script>



// WEBPACK FOOTER //
// src/views/settings/basic/DeviceRegistration/E2eDevice/E2eRegistWizardForAgent.vue